import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { Observable, filter, map, take } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoginActivateGuard {
    constructor(private authService: AuthService, private router: Router) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.authService.isLogged().pipe(
            take(1),
            map((resp) => {
                if (resp.logged) {
                    return true;
                } else {
                    return this.router.createUrlTree(['/login']);
                }
            })
        );
    }
}
